import { instance } from "../instance";

export const postSubscription = async (data: any) => {
  return instance({
    method: "post",
    url: "/subscriptions",
    data,
  });
};

export const getUserSubscriptions = async (userId: string) => {
  return instance({
    method: "get",
    url: `/subscriptions?userId=${userId}`,
  });
};

export const deleteSingleSubscription = async (subscriptionId: string) => {
  return instance({
    method: "delete",
    url: `/subscriptions?subscriptionId=${subscriptionId}`,
  });
};
